import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';

//import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

import PaymentModule from '../payment/payment';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

//import './css/index.css';
//import './css/header.css';

class AccountInvoice extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			invoice: {},
			//show: false,
			//filenames: [],
			//servers: [],
			/*websites: [],
			ips: [],
			ip: '',*/
			/*sort: {
				column: '',
				order: ''
			}*/


			//invoice: false,
			//invoice: {},
		};
    this.getInvoice = this.getInvoice.bind(this);
		this.makePayment = this.makePayment.bind(this);
		//this.showInvoice = this.showInvoice.bind(this);
	
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		//this.getWebsites();

		

		//this.setState({status: true});
		//this.enable();

		this.getInvoice();

	}

	componentWillUnmount() {
	}


	async getInvoice() {
		let params = new URLSearchParams();
		const x = await postApi(`/v3/account/invoice/${this.props.invoice}`, params);
		//console.log(x.data);
		if( x.status === 200 ) {
      this.setState({status: true, invoice: x.data});
    } else {
      window.location.href = '/invoices';
    }
	}

	
  async makePayment(method, payment) {
    //console.log(payment);
    
    let params = new URLSearchParams();
    params.append("method", method);
    params.append("payment", payment);
		const x = await putApi(`/v3/payment/payment/${this.state.invoice.invoice.id}`, params);
    //console.log(x.data);

    if( x.status === 200 ) {
      await this.getInvoice();
    }

    return x.data;
  }


	render() {
		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Invoices</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Invoices</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>

									
                  <Col xs={12}>
                    <div className="card custom-card overflow-hidden">
                      <div className="card-header justify-content-between">
                        <div className="card-title">Invoice #US{this.state.invoice?.invoice?.id}</div>
                        <div className="dropdown d-flex">
                          <Button size="sm">Print</Button>&nbsp;
                          <Link to={'/invoices'}><Button size="sm">Close</Button></Link>
                        </div>
                      </div>
                      {this.state.invoice.invoice &&
                        <div className="card-body">
                          <div className="row gy-3">
                            <div className="col-xl-12">
                              <div className="row">
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                  <p className="text-muted mb-2">
                                    Billing From :
                                  </p>
                                  <p className="fw-bold mb-1">
                                    {this.state.invoice?.billingFrom?.company}
                                  </p>
                                  <p className="mb-1 text-muted">
                                    {this.state.invoice?.billingFrom?.email}
                                  </p>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 ms-auto mt-sm-0 mt-3">
                                  <p className="text-muted mb-2">
                                    Billing To :
                                  </p>
                                  <p className="fw-bold mb-1">
                                    {this.state.invoice?.billingTo?.name}
                                  </p>
                                  <p className="text-muted mb-1">
                                    {this.state.invoice?.billingTo?.email}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-4">
                              <p className="fw-semibold text-muted mb-1">Invoice ID :</p>
                              <p className="fs-15 mb-1">#US{this.state.invoice?.invoice?.id}</p>
                            </div>
                            {this.state.invoice?.invoice?.ctime &&
                            
                              <div className="col-xl-4">
                                <p className="fw-semibold text-muted mb-1">Date Issued :</p>
                                <p className="fs-15 mb-1">{moment(new Date(this.state.invoice?.invoice?.ctime*1000)).format("DD MMM YYYY")} - <span className="text-muted fs-12">{moment(this.state.invoice?.invoice?.ctime*1000).format("h:mm A")}</span></p>
                              </div>
                            }
                            <div className="col-xl-4">
                              <p className="fw-semibold text-muted mb-1">Due Amount :</p>
                              <p className="fs-16 mb-1 fw-semibold">£{this.state.invoice?.invoice?.total.toFixed(2)}</p>
                            </div>
                            <div className="col-xl-12">
                              <div className="table-responsive">
                                <table className="table nowrap text-nowrap border mt-4">
                                  <thead>
                                    <tr>
                                      <th>PRODUCT NAME</th>
                                      <th>DESCRIPTION</th>
                                      <th>PRICE</th>
                                      <th>TOTAL</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(() => {
                                      return this.state.invoice?.items?.map((f,j) => {
                                        return (
                                          <tr key={j}>
                                            <td>
                                              <div className="fw-semibold">
                                                {f.product}
                                              </div>
                                              <div className="text-success">
                                                {(() => {
                                                  return f.coupons?.map((g,k) => {
                                                    return (
                                                      <React.Fragment key={k}>
                                                        {g.name}<br />
                                                      </React.Fragment>
                                                    )
                                                  })
                                                })()}
                                              </div>
                                            </td>
                                            <td>
                                              <div className="text-muted">
                                                {f.title}
                                              </div>
                                            </td>
                                            <td>
                                              £{f.price.toFixed(2)}
                                            </td>
                                            <td>
                                              <div className={f.price!==f.total&&'text-success'}>
                                                £{f.total.toFixed(2)}
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      })
                                    })()}
                                    <tr>
                                      <td colSpan="2"></td>
                                      <td colSpan="2">
                                        <table className="table table-sm text-nowrap mb-0 table-borderless">
                                          <tbody>
                                            <tr>
                                              <th scope="row">
                                                <p className="mb-0">Sub Total :</p>
                                              </th>
                                              <td>
                                                <p className="mb-0 fw-semibold fs-15">£{this.state.invoice?.invoice?.price.toFixed(2)}</p>
                                              </td>
                                            </tr>
                                            <tr>
                                              <th scope="row">
                                                <p className="mb-0 text-success">Coupon Discount :</p>
                                              </th>
                                              <td>
                                                <p className="mb-0 fw-semibold fs-15 text-success">£{(this.state.invoice?.invoice?.price-this.state.invoice?.invoice?.total).toFixed(2)}</p>
                                              </td>
                                            </tr>
                                            {/*<tr>
                                              <th scope="row">
                                                <p className="mb-0">Vat <span className="text-danger">(20%)</span> :</p>
                                              </th>
                                              <td>
                                                <p className="mb-0 fw-semibold fs-15">$472.80</p>
                                              </td>
                                            </tr>*/}
                                            <tr>
                                              <th scope="row">
                                                <p className="mb-0 fs-14">Total :</p>
                                              </th>
                                              <td>
                                                <p className="mb-0 fw-semibold fs-16">£{this.state.invoice?.invoice?.total.toFixed(2)}</p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                    {this.state.invoice?.invoice?.receipt !== '0' &&
                                      <tr>
                                        <td colSpan="4" className="text-center"><span className="badge bg-success-transparent fw-semibold fs-16">Paid</span> Receipt: {this.state.invoice?.invoice?.receipt}</td>
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            

                          </div>
                        </div>
                      }
                    </div>
                  </Col>
                  {this.state.invoice?.invoice?.receipt === '0' &&
                    <Col sm={12}>
                      <div className="card custom-card overflow-hidden">
                        <div className="card-header justify-content-between">
                          <div className="card-title">Payment Method</div>
                        </div>
                        <div className="card-body">
                          <PaymentModule order={this.state.invoice.invoice.id} makePayment={this.makePayment} />
                        </div>
                      </div>
                    </Col>
                  }
										
								</Row>
							</div>
						</div>
					</div>
				}
			</>
		);
	}
}

const Invoice = props => {
  const { invoice } = useParams();
  return <AccountInvoice invoice={invoice} {...props} />
}
export default Invoice;